module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "contacts-manual-picker"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "titleized"
  }, [_vm._v(_vm._s(_vm.$t('contacts_group.title.manuallyPicker')))]), _vm._m(0)]), _c('div', {
    staticClass: "modal-body"
  }, [_c('contacts-picker-text-csv', {
    attrs: {
      "has_groups": _vm.has_groups
    }
  })], 1), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]), _c('div', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.selectContacts
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.conclude')))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c9f0e04!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contacts/picker/manually.vue
// module id = 1011
// module chunks = 1